var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"faq-item",on:{"click":function($event){return _vm.onItemClick(_vm.faqItem)}}},[_c('span',{staticClass:"item"},[_vm._v(_vm._s(_vm.faqItem.title))]),_vm._v(" "),_c('span',{staticClass:"right-arrow"})])}
var staticRenderFns = []

export { render, staticRenderFns }